import React from "react";

function Cart_header() {

    return (
        <div className="cart-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>سبد خرید</h1>
                        <p>
                            <i className="far fa-dot-circle"></i>
                            سفارش های شما
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Cart_header;